import icon from "images/layout/chevron-right-white.svg"
import parse from "html-react-parser"

export default function ChevronRightIcon() {
  return (
    <span className="svg-icon">{parse(icon)}</span>
  )
}
